import { action } from 'typesafe-actions';
import { VASProcessedTypes } from './types';
import { VASReportResponse, DataStream } from '../../interfaces';

export const viewVASOverviewRequest = (payload: any) =>
  action(VASProcessedTypes.VIEW_VAS_OVERVIEW_REQUEST, payload);

export const viewVASOverviewSuccess = (data: VASReportResponse) =>
  action(VASProcessedTypes.VIEW_VAS_OVERVIEW_SUCCESS, data);

export const viewVASOverviewFailure = (error: any) =>
  action(VASProcessedTypes.VIEW_VAS_OVERVIEW_FAILURE, error);

export const exportViewVASOverviewRequest = (payload: any) =>
  action(VASProcessedTypes.EXPORT_VIEW_VAS_OVERVIEW_REQUEST, payload);

export const exportViewVASOverviewSuccess = (data: DataStream) =>
  action(VASProcessedTypes.EXPORT_VIEW_VAS_OVERVIEW_SUCCESS, data);

export const exportViewVASOverviewFailure = (error: any) =>
  action(VASProcessedTypes.EXPORT_VIEW_VAS_OVERVIEW_FAILURE, error);

export const clearVAS = () => action(VASProcessedTypes.CLEAR_VAS);
